// Header.js
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';
import languages from '../i18n/languages.json';
import { checkAndUpdateLanguage } from '../i18n/i18n';

const Header = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const newLanguage = checkAndUpdateLanguage(i18n.language);
    if (newLanguage !== i18n.language) {
      i18n.changeLanguage(newLanguage);
    }
  }, [i18n]);

  const changeLanguage = (lng) => {
    const newLanguage = checkAndUpdateLanguage(lng);
    i18n.changeLanguage(newLanguage).then(() => {
      try {
        localStorage.setItem('i18nextLng', newLanguage);
      } catch {}
      console.log('Language changed to:', newLanguage);
      window.dispatchEvent(new Event('languageChanged'));
    });
  };


  return (
    <Navbar expand="lg" fixed="top" className="full-width-header">
      <Navbar.Brand as={Link} to="/">phoenix.ai</Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link as={Link} to="/">{t('Home')}</Nav.Link>
          <Nav.Link as={Link} to="/AI4Good">{t('A.I. Transformation')}</Nav.Link>
          {/* <Nav.Link as={Link} to="/project">{t('Project')}</Nav.Link> */}
          <Nav.Link as={Link} to="/aboutus">{t('About Us')}</Nav.Link>
          
          <NavDropdown 
            title={
              <span>
                <i className="fas fa-globe">&nbsp; </i> {t('Language')}
              </span>
            } 
            id="language-nav-dropdown"
          >
            {Object.entries(languages).map(([code, name]) => (
              <NavDropdown.Item key={code} onClick={() => changeLanguage(code)}>
                {name}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
